// extracted by mini-css-extract-plugin
export default {"wrapper":"U1-z","play":"V1-z"};